const DATE_REGEX = /\b\d{2}\/\d{2}\/\d{4} \d{2}:\d{2}:\d{2}\b/;

/* Returns the value from a line formated as "KEY : VALUE" */
export function getValueFromLine(line: string): string {
  const array = line.split(':');
  if (array.length >= 2) return array[1].trim();
  return '';
}

/* Returns a Date from a line formated as "KEY : DD/MM/YYYY HH:MM:SS" */
export function getDateFromLine(line: string, utc = 2): Date {
  const matches: RegExpMatchArray | null = line.match(DATE_REGEX);

  if (!matches) return new Date(0);

  const dateString: string = matches[0];

  // Split the date string into date and time components
  const [datePart, timePart]: string[] = dateString.split(' ');

  // Split the date component into day, month, and year
  const [day, month, year]: string[] = datePart.split('/');

  // Split the time component into hours, minutes, and seconds
  const [hours, minutes, seconds]: string[] = timePart.split(':');

  // Create a new Date object with the parsed values
  const parsedDate: Date = new Date(
    Number(year),
    Number(month) - 1,
    Number(day),
    Number(hours),
    Number(minutes),
    Number(seconds)
  );

  // Adjust the parsedDate to UTC+2
  parsedDate.setUTCHours(parsedDate.getUTCHours() + utc);

  return parsedDate;
}
